// resources/js/bootstrap/jquery.js
import jQuery from 'jquery';

// Legacy dosyalar global jQuery beklediği için mutlaka global'e yaz
globalThis.jQuery = globalThis.jQuery || jQuery;
globalThis.$ = globalThis.$ || jQuery;

export default jQuery;
